import { baseZIndex } from 'components/GridTable/consts'
import type {
  GridTableColumn,
  GridTableContentSectionItem,
  PossibleValuesRecord,
} from 'components/GridTable/types'
import { memo } from 'react'
import { colors } from 'settings/colors'

const ValueCellWithNoMemoization = ({
  column,
  render,
  value,
  values,
  width,
}: {
  column: GridTableColumn
  render: GridTableContentSectionItem['render']
  value: PossibleValuesRecord | undefined
  values: Record<string, PossibleValuesRecord>
  width: number
}) => (
  <div
    css={{
      width,
      height: '100%',
      boxSizing: 'border-box',
      border: `1px solid ${colors.grey200}`,
      borderCollapse: 'collapse',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      columnGap: '17px',
      fontWeight: 500,
      fontSize: '14px',
      zIndex: baseZIndex - 3,
      ...column.valueCellCSS,
    }}
  >
    {render(value, column, values)}
  </div>
)

export const ValueCell = memo(ValueCellWithNoMemoization)
